import {
  IconButton,
  Stack,
  TabPanel,
  TabPanelProps,
  Td,
  Th,
  Tr,
  useToast,
} from '@chakra-ui/react';
import {
  useFetchVendorsPageQuery,
  usePostVendorMutation,
  usePutVendorMutation,
} from 'api';
import { useAuth, usePagination } from 'core';
import { AppButton } from 'features/components';
import { AppTable } from 'features/table';
import { useMemo, useState } from 'react';
import { VendorResponse } from 'api/bindings/VendorResponse';
import { VendorModel } from 'api/bindings/VendorModel';
import { FiEdit, FiPlus } from 'react-icons/fi';
import { EditVendorFormDrawer } from './EditVendorFormDrawer';
import { PostVendorRequest } from 'api/bindings/PostVendorRequest';
import { PutVendorRequest } from 'api/bindings/PutVendorRequest';
import { CreateVendorDrawer } from './CreateVendorFormDrawer';

export interface ClientVendorsTabPanelProps extends TabPanelProps {}

type SuperPutVendorRequest = { id: string } & PutVendorRequest;
type VendorRequest = PostVendorRequest | SuperPutVendorRequest;

function isPutVendorRequest(r: VendorRequest): r is SuperPutVendorRequest {
  return 'id' in r;
}
function isPostVendorRequest(r: VendorRequest): r is PostVendorRequest {
  return !isPutVendorRequest(r);
}

export const ClientVendorsTabPanel = (props: ClientVendorsTabPanelProps) => {
  const { ...others } = props;
  const auth = useAuth();
  const [pagination, setPagination] = usePagination();
  const { data: vendors, isLoading } = useFetchVendorsPageQuery(
    { ...pagination },
    { skip: !auth?.user?.clientId }
  );
  // const [postVendor] = usePostVendorMutation();
  // const [putVendor] = usePutVendorMutation();
  const [createVendor, setCreateVendor] = useState<boolean>();
  const [editingVendor, setEditingVendor] = useState<VendorResponse>();

  const disallowedVendorNames = useMemo(
    () => vendors?.items.map((x) => x.name),
    [vendors?.items]
  );

  let body = (
    <>
      <Tr>
        <Td></Td>
        <Td colSpan={2}>Loading...</Td>
      </Tr>
    </>
  );

  if (!isLoading) {
    body = (
      <>
        {vendors?.items.map((v, i) => (
          <Tr key={i}>
            <Td>
              <IconButton
                aria-label="Edit Vendor"
                icon={<FiEdit />}
                onClick={() => {
                  console.debug('opening panel');
                  setEditingVendor(v);
                }}
              />
            </Td>

            <Td>{v.name}</Td>
            {/* <Td>
              <AppButton onClick={() => setEditingVendor(v)}>Edit</AppButton>
            </Td> */}
          </Tr>
        ))}
      </>
    );
  }
  return (
    <TabPanel {...others}>
      {editingVendor && (
        <EditVendorFormDrawer
          vendor={editingVendor}
          isOpen={true}
          placement="right"
          onClose={() => setEditingVendor(undefined)}
          disallowedVendorNames={disallowedVendorNames}
        />
      )}
      {createVendor && (
        <CreateVendorDrawer
          isOpen={true}
          disallowedVendorNames={disallowedVendorNames}
          onClose={() => setCreateVendor(undefined)}
          size="xl"
        />
      )}
      <Stack>
        <AppTable
          title="Search Vendors"
          header={
            <>
              <Tr>
                <Th></Th>
                <Th>Name</Th>
              </Tr>
            </>
          }
          buttonGroup={(props) => (
            <AppButton
              leftIcon={<FiPlus />}
              variant={'solid'}
              onClick={() => setCreateVendor(true)}
            >
              Create Vendor
            </AppButton>
          )}
          body={body}
          onPaginationChange={setPagination}
          pagination={{
            ...pagination,
            itemCount: Number(vendors?.itemCount ?? 0),
            pageCount: Number(vendors?.pageCount ?? 0),
          }}
        />
      </Stack>
    </TabPanel>
  );
};
